// SelectStyles.js
const selectStylesV1 = (theme) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? "transparent" : "transparent",
    backgroundColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: "none",
    "&:hover": {
      borderColor: state.isFocused ? "transparent" : "transparent",
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#2A77EB",
    ":hover": {
      color: "#2A77EB",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#2A77EB",
    ":hover": {
      color: "#2A77EB",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#619AF0",
    fontSize: 18,
    fontWeight: "500",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: 18,
    color: theme === "dark" ? "white" : "#4D4E50",
    fontWeight: "500",
  }),
  input: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#FFFFFF" : "#333333",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "#2A77EB"
        : "#e0e0e0"
      : state.isFocused
        ? theme === "dark"
          ? "#636363"
          : "#f0f0f0"
        : "inherit",
    color:
      state.isSelected || state.isFocused
        ? theme === "dark"
          ? "white"
          : "#333333"
        : theme === "dark"
          ? "#d1d1d1"
          : "#333333",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: theme === "dark" ? "#384049" : "white",
  }),
});

// SelectStylesV2.js
const selectStylesV2 = (theme) => ({
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: 14,
    color: "#acafb5",
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "8px",
    borderColor: theme === "dark" ? "#080d17" : state.isFocused ? "#2A77EB" : "#E5E7EB",
    backgroundColor: theme === "dark" ? "#080d17" : "#F9FAFB",
    fontSize: "0.875rem",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(42, 119, 235, 0.2)" : "none",
    "&:hover": {
      borderColor: theme === "dark" ? "transparent" : "",
    },
    "&::placeholder": {
      fontSize: "0.75rem",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#adadad" : "#4D4E50",
    fontWeight: "500",
  }),
  input: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#FFFFFF" : "#333333",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "#2A77EB"
        : "#e0e0e0"
      : state.isFocused
        ? theme === "dark"
          ? "#636363"
          : "#f0f0f0"
        : "inherit",
    color:
      state.isSelected || state.isFocused
        ? theme === "dark"
          ? "white"
          : "#333333"
        : theme === "dark"
          ? "#d1d1d1"
          : "#333333",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: theme === "dark" ? "#384049" : "white",
  }),
});

// SelectStylesV3.js
const selectStylesV3 = (theme) => ({
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: 14,
    color: "#acafb5",
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "8px", // Matches `rounded-md`
    borderColor: theme === "dark" ? "#080d17" : state.isFocused ? "#2FA84F" : "#E5E7EB", // Matches `focus:border-green-500` and default border
    backgroundColor: theme === "dark" ? "#080d17" : "#F9FAFB", // Matches `bg-[#F9FAFB]`
    fontSize: "0.875rem", // Matches `text-sm`
    boxShadow: state.isFocused ? "0 0 0 2px rgba(47, 168, 79, 0.2)" : "none",
    "&:hover": {
      borderColor: theme === "dark" ? "transparent" : "", // Matches `focus:border-green-500`
    },
    "&::placeholder": {
      fontSize: "0.75rem", // Matches `placeholder:text-sm`
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme == "dark" ? "#adadad" : "#4D4E50",
    fontWeight: "500",
  }),
  input: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#FFFFFF" : "#333333", // Typing input text color
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "#2A77EB" // Neutral dark selected background
        : "#e0e0e0" // Neutral light selected background
      : state.isFocused
        ? theme === "dark"
          ? "#636363" // Neutral dark hover background
          : "#f0f0f0" // Neutral light hover background
        : "inherit",
    color:
      state.isSelected || state.isFocused
        ? theme === "dark"
          ? "white"
          : "#333333" // White text for selected or hovered
        : theme === "dark"
          ? "#d1d1d1" // Neutral light gray for dark theme
          : "#333333", // Neutral dark gray for light theme
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: theme === "dark" ? "#384049" : "white",
  }),
});

const selectStylesV4 = (theme) => ({
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: 14,
    color: "#acafb5",
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "8px", // Matches `rounded-md`
    borderColor: theme === "dark" ? "#080d17" : state.isFocused ? "#FF602B" : "#E5E7EB", // Matches `focus:border-green-500` and default border
    backgroundColor: theme === "dark" ? "#080d17" : "#F9FAFB", // Matches `bg-[#F9FAFB]`
    fontSize: "0.875rem", // Matches `text-sm`
    boxShadow: state.isFocused ? "0 0 0 2px rgba(255, 96, 43, 0.2)" : "none",
    "&:hover": {
      borderColor: theme === "dark" ? "transparent" : "", // Matches `focus:border-green-500`
    },
    "&::placeholder": {
      fontSize: "0.75rem", // Matches `placeholder:text-sm`
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme == "dark" ? "#adadad" : "#4D4E50",
    fontWeight: "500",
  }),
  input: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#FFFFFF" : "#333333", // Typing input text color
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "#2A77EB" // Neutral dark selected background
        : "#e0e0e0" // Neutral light selected background
      : state.isFocused
        ? theme === "dark"
          ? "#636363" // Neutral dark hover background
          : "#f0f0f0" // Neutral light hover background
        : "inherit",
    color:
      state.isSelected || state.isFocused
        ? theme === "dark"
          ? "white"
          : "#333333" // White text for selected or hovered
        : theme === "dark"
          ? "#d1d1d1" // Neutral light gray for dark theme
          : "#333333", // Neutral dark gray for light theme
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: theme === "dark" ? "#384049" : "white",
  }),
});

const selectStylesV5 = (theme) => ({
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: 14,
    color: "#acafb5",
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "8px", // Matches `rounded-md`
    borderColor: theme === "dark" ? "#080d17" : state.isFocused ? "#2FA84F" : "#E5E7EB", // Matches `focus:border-green-500` and default border
    backgroundColor: theme === "dark" ? "#080d17" : "#F9FAFB", // Matches `bg-[#F9FAFB]`
    fontSize: "0.875rem", // Matches `text-sm`
    boxShadow: state.isFocused ? "0 0 0 2px rgba(47, 168, 79, 0.2)" : "none",
    "&:hover": {
      borderColor: theme === "dark" ? "transparent" : "", // Matches `focus:border-green-500`
    },
    "&::placeholder": {
      fontSize: "0.75rem", // Matches `placeholder:text-sm`
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme == "dark" ? "#adadad" : "#4D4E50",
    fontWeight: "500",
  }),
  input: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#FFFFFF" : "#333333", // Typing input text color
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "#2A77EB" // Neutral dark selected background
        : "#e0e0e0" // Neutral light selected background
      : state.isFocused
        ? theme === "dark"
          ? "#636363" // Neutral dark hover background
          : "#f0f0f0" // Neutral light hover background
        : "inherit",
    color:
      state.isSelected || state.isFocused
        ? theme === "dark"
          ? "white"
          : "#333333" // White text for selected or hovered
        : theme === "dark"
          ? "#d1d1d1" // Neutral light gray for dark theme
          : "#333333", // Neutral dark gray for light theme
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: theme === "dark" ? "#384049" : "white",
  }),
});

export { selectStylesV1, selectStylesV2, selectStylesV3, selectStylesV4, selectStylesV5 };
